import { getRestlaufzeitFromSails } from '@vfde-sails/storage';
import { SailsTariffOverviewStorage } from 'Container/App/interface';

/**
 * Get getRestlaufzeit from storage
 */
export const getRestlaufzeit = (storage: SailsTariffOverviewStorage | null): boolean => {
    if (!storage) {
        return false;
    }

    return getRestlaufzeitFromSails(storage);
};
